import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Api from 'api';
import BankIdLoginComponent from 'modules/users/components/bankid-login';
import { userData as userDataSelector } from 'selectors/user';
import { fetchUserSelfRequest } from 'actions';

const isPageReady = () =>
  new Promise((resolve) => {
    // eslint-disable-line
    const el = document.getElementById('core-id-container');

    if (el && window.coreid_client) {
      return resolve();
    }

    window.onload = () => resolve(isPageReady());
  });

class BankIdLoginContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      isLoading: true,
      missmatch: false,
      errors: null,
    };
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {
    if (window.coreid_client && window.coreid_client.close) {
      window.coreid_client.close();
    }
  }

  init = async () => {
    const data = await Api.fetchBankIdToken();

    await isPageReady();

    window.coreid_client.init({
      token: data.token,
      config: {
        allowedEids: ['*'],
        mode: 'auth',
        language: this.props.user.language.toLowerCase(),
        provider: 'se-bankid',
        providerSettings: {
          'se-bankid': {
            redirectMode: 'never',
          },
        },
      },
      callback: this.onResponse,
      injectIntoNode: '#core-id-container',
    });

    window.coreid_client.start();

    this.setState({ isLoading: false });
  };

  login = async (token) => {
    try {
      const data = await Api.bankIdLogin(token);

      if (!data.success) {
        if (data.error === 'INFORMATION_MISSMATCH') {
          this.setState({ missmatch: true, errors: data.errors });
        }

        return;
      }

      this.props.fetchUserSelfRequest();

      if (this.props.onSuccess) {
        this.props.onSuccess();
      }
    } catch (err) {
      this.setState({ error: 'There was an error contacting BankID' });

      if (this.props.onFailure) {
        this.props.onFailure();
      }
    }
  };

  onResponse = (response) => {
    if (!response) {
      return;
    }

    if (response.type === 'authenticated' && response.success === true) {
      const { token } = response;

      this.login(token);

      window.coreid_client.close();
    }

    if (response.type === 'failed' || response.type === 'error') {
      this.setState({ error: response.errorMessage });
    }
  };

  render() {
    return (
      <BankIdLoginComponent
        error={this.state.error}
        missmatch={this.state.missmatch}
        errors={this.state.errors}
        isLoading={this.state.isLoading}
      />
    );
  }
}

BankIdLoginContainer.propTypes = {
  user: PropTypes.shape({
    language: PropTypes.oneOf(['EN', 'SV']),
  }).isRequired,
  onSuccess: PropTypes.func,
  onFailure: PropTypes.func,
  fetchUserSelfRequest: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: userDataSelector(state),
});

const mapDispatchToProp = (dispatch) => ({
  fetchUserSelfRequest: () => dispatch(fetchUserSelfRequest()),
});

export default connect(mapStateToProps, mapDispatchToProp)(BankIdLoginContainer);
